import styled from 'styled-components'

import { ThemeModeType } from '@src/Application/Types/ComponentTypes'

export const Title = styled.div<{ $mode: ThemeModeType }>`
    ${(props) => props.theme.typo.displayM};
    ${(props) => props.theme.fontWeight.light};
    color: ${(props) => (props.$mode === 'Light' ? props.theme.color.black : props.theme.color.white)};
    margin-bottom: 20px;
    text-align: center;

    span {
        color: ${(props) => props.theme.color.a500};
    }

    @media ${(props) => props.theme.query.min.tablet} {
        ${(props) => props.theme.typo.displayXL};
        text-align: left;
    }
`
